import React, {useEffect, useState} from "react";
import {useHttp} from "../../../services/HttpService";
import {
    getAnlagenartEndpoint,
    getAnlagentypEndpoint,
    getBetriebsTypEndpoint,
    getEntlastungsanlagenartEndpoint
} from "../../../services/WertelistenService";
import ErweiterteSuche from "../ErweiterteSuche";
import EAButtonBar from "../../EAButtonBar";
import EAButton from "../../EAButton";
import EAFieldset from "../../EAFieldset";
import {
    getAbwasserbeseitigungspflichtigeEndpoint,
    getBetreiberByBetriebstypEndpoint,
    getBetreiberEndpoint, getBetreiberPersonalisiertEndpoint
} from "../../../services/OrganisationsService";
import {einleiterOptionen} from "../../../consts/valueLists";
import {useAnlagenstatus} from "../../../services/AnlagenService";
import {personalisierungEndpoint} from "../../../services/AnwenderService";

export default function AnlageArbeitsListeSuche({
                                                    formFactory,
                                                    attr,
                                                    sharedFilter,
                                                    onErweiterteSucheOpenChanged,
                                                    sharedFormFactory,
                                                    regionalstelleOptionen,
                                                    raeumlichesKriteriumOptionen,
                                                    behoerdeOptionen,
                                                    setStoredFilter,
                                                    setFilter,
                                                    resetSharedFilter,
                                                    defaultSearchParameters,
                                                    executeSearch,
                                                    storedFilter,
                                                    setSelected,
                                                    filter,
                                                    id
                                                }) {
    const filterFieldId = "anlagebezeichnung-filter";

    const [betriebstyp, setBetriebstyp] = useState();
    const [anlagenTypOptionen] = useHttp(getAnlagentypEndpoint);
    const [anlagenartOptionen] = useHttp(getAnlagenartEndpoint);
    const [entlastungsanlagenartOptionen] = useHttp(getEntlastungsanlagenartEndpoint);
    const [betriebTypOptionen] = useHttp(getBetriebsTypEndpoint);
    const [organisationOptionen, refetchOrganisationOptionen] = useHttp(getEndpoint());
    const [abwasserbeseitigungspflichtigeOptionen] = useHttp(getAbwasserbeseitigungspflichtigeEndpoint);
    const [anlagenstatusOptionen] = useAnlagenstatus();
    const [options, setOptions] = useState();

    const [personalisierungsfilter, refetchPersonalisierungsfilter] = useHttp(personalisierungEndpoint);
    const [betriebstypPersonalisiert, setBetriebstypPersonalisiert] = useState(false);
    const [anlagentypPersonalisiert, setAnlagentypPersonalisiert] = useState(false);
    const [raeumlichesKriteriumPersonalisiert, setRaeumlichesKriteriumPersonalisiert] = useState(false);

    useEffect(() => {
        let newBetriebstypValue = false;
        let newAnlagentypValue = false;
        let newVerwaltungseinheitValue = false;

        if (personalisierungsfilter.data) {
            if (personalisierungsfilter.data.betriebstyp && sharedFilter.personalisiert) {
                newBetriebstypValue = true;
            }
            if (personalisierungsfilter.data.anlagentyp && sharedFilter.personalisiert) {
                newAnlagentypValue = true;
            }
            if (personalisierungsfilter.data.verwaltungseinheit && sharedFilter.personalisiert) {
                newVerwaltungseinheitValue = true;
            }
        }

        setBetriebstypPersonalisiert(newBetriebstypValue);
        setAnlagentypPersonalisiert(newAnlagentypValue);
        setRaeumlichesKriteriumPersonalisiert(newVerwaltungseinheitValue);
    }, [personalisierungsfilter, sharedFilter.personalisiert]);

    useEffect(() => {
        refetchPersonalisierungsfilter();
    }, [sharedFilter.personalisiert, refetchPersonalisierungsfilter]);

    useEffect(() => {
        if (filter.betriebTyp) {
            setBetriebstyp(filter.betriebTyp.id);
        }
    }, [organisationOptionen, filter.betriebTyp]);

    const getErweiterteSuche = () => {
        return (
            <div className="gridl" style={{gridColumn: "span 4", gridTemplateColumns: "220px 400px 200px 200px"}}>
                {formFactory.renderAutocomplete(
                    attr.anlagenart,
                    filterFieldId + "-" + attr.anlagenart,
                    "Anlagenart",
                    options,
                    "value",
                    "id",
                    anlagenartOptionen.loading
                )}
                {formFactory.renderSelect(
                    attr.indirekteinleiter,
                    filterFieldId + "-" + attr.indirekteinleiter,
                    "Einleitung",
                    einleiterOptionen,
                    false,
                    {required: true}
                )}
            </div>
        );
    }

    function getEndpoint() {
        if (sharedFilter.personalisiert) {
            return getBetreiberPersonalisiertEndpoint;
        }
        else if (betriebstyp) {
            return getBetreiberByBetriebstypEndpoint(betriebstyp);
        }
        else {
            return getBetreiberEndpoint;
        }
    }

    function filterBetreiber(betriebstyp) {
        if (betriebstyp) {
            setBetriebstyp(betriebstyp.id);
        }
        else {
            setBetriebstyp(null);
        }
    }

    useEffect(() => {
        refetchOrganisationOptionen();
    }, [betriebstyp, refetchOrganisationOptionen]);

    useEffect(() => {
        if (!anlagenstatusOptionen.loading && !entlastungsanlagenartOptionen.loading) {
            const o = anlagenartOptionen.data;
            if (o) {
                o.push(...entlastungsanlagenartOptionen.data);
                setOptions(o);
            }
        }
    }, [anlagenartOptionen.data, anlagenstatusOptionen.loading, entlastungsanlagenartOptionen.data, entlastungsanlagenartOptionen.loading]);

    return (
        <EAFieldset id={id} caption="Suche">
            <div className="simpleFilter gridl">
                {formFactory.renderAutocomplete(
                    attr.organisation,
                    filterFieldId + "-" + attr.organisation,
                    "Betreiber",
                    organisationOptionen.data,
                    "bezeichnung",
                    "id",
                    organisationOptionen.loading
                )}
                {formFactory.renderAutocompletePersonalisiert(
                    attr.betriebTyp,
                    filterFieldId + "-" + attr.betriebTyp,
                    "Betriebstyp",
                    betriebTypOptionen.data,
                    "value",
                    "id",
                    betriebTypOptionen.loading,
                    false,
                    false,
                    null,
                    null,
                    betriebstypPersonalisiert,
                    (value) => {
                        filterBetreiber(value);
                    }
                )}
                {formFactory.renderInput(
                    attr.anlagenId,
                    filterFieldId + "-" + attr.anlagenId,
                    "Anlagennummer"
                )}
                {formFactory.renderInput(
                    attr.anlagenBezeichnung,
                    filterFieldId + "-" + attr.anlagenBezeichnung,
                    "Abwasseranlagenbezeichnung"
                )}
                {formFactory.renderAutocompletePersonalisiert(
                    attr.anlagentyp,
                    filterFieldId + "-" + attr.anlagentyp,
                    "Anlagentyp",
                    anlagenTypOptionen.data,
                    "value",
                    "id",
                    anlagenTypOptionen.loading,
                    false,
                    false,
                    null,
                    null,
                    anlagentypPersonalisiert
                )}
                {formFactory.renderAutocomplete(
                    attr.anlagenstatus,
                    filterFieldId + "-" + attr.anlagenstatus,
                    "Anlagenstatus",
                    anlagenstatusOptionen.data,
                    "value",
                    "id",
                    anlagenstatusOptionen.loading
                )}
            </div>
            <ErweiterteSuche
                sharedFilter={sharedFilter}
                onExtendedSearchOpenChanged={onErweiterteSucheOpenChanged}
                sharedFormFactory={sharedFormFactory}
                regionalstelleOptionen={regionalstelleOptionen}
                raeumlichesKriteriumOptionen={raeumlichesKriteriumOptionen}
                behoerdeOptionen={behoerdeOptionen}
                additionalPrefixFields={[
                    formFactory.renderAutocomplete(
                        attr.abwasserbeseitigungspflichtiger,
                        filterFieldId + "-" + attr.abwasserbeseitigungspflichtiger,
                        "Abwasserbeseitigungspflichtiger",
                        abwasserbeseitigungspflichtigeOptionen.data,
                        "bezeichnung",
                        "id",
                        abwasserbeseitigungspflichtigeOptionen.loading
                    ),
                ]}
                additionalSuffixFields={[getErweiterteSuche()]}
                raeumlichesKriteriumPersonalisiert={raeumlichesKriteriumPersonalisiert}
            />
            <EAButtonBar style={{marginTop: "var(--buttonBar-spacing-top)"}}>
                <EAButton
                    id={filterFieldId + "-reset"}
                    label="Zurücksetzen"
                    onClick={() => {
                        setStoredFilter(defaultSearchParameters);
                        setFilter(defaultSearchParameters);
                        executeSearch(defaultSearchParameters, sharedFilter);
                    }}
                />
                <EAButton
                    id={filterFieldId + "-submit"}
                    label="Suchen"
                    onClick={() => {
                        let newStoredFilter = {...filter, pageInfo: {...storedFilter.pageInfo, page: 0}};
                        setStoredFilter(newStoredFilter);
                        setSelected([]);
                        executeSearch(newStoredFilter, sharedFilter);
                    }}
                    color="primary"/>
            </EAButtonBar>
        </EAFieldset>
    );
}
